<template>
  <div>
     <p class="horizontal-text">核心产业信息：</p>
    <SelectTreeRadio
      :isTree="true"
      apiName="getIndustryList"
      :params="{
        groupLabelType: '赋能行业标签组',
        level: 4,
      }"
      resultType="values"
      storageKey="industryCategoryList"
      v-model="reportLabelList"
      :isRadioFirstLevel="false"
      :isCheckBoxButton="false"
    ></SelectTreeRadio>
  </div>
</template>
<script>
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";
export default {
  data() {
    return {
      reportLabelList: [],
    };
  },

  components: {
    SelectTreeRadio,
  },
};
</script>
<style lang="less" scoped>
div{
    display: flex;
}
.horizontal-text {
  white-space: nowrap; /* 防止文字换行 */
  margin-top: 10px;
  padding-right: 15px;
  font-size: 16px;
  color: #333;
}
::v-deep .el-checkbox {
    line-height: 40px;
}
</style>